import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/i18n";
import { EnquireProvider } from "@/components/ContactModal";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Biography from "@/pages/Biography";
import VJ8C from "@/pages/VJ8C";
import BiVenti from "@/pages/BiVenti";

const SmoothScroll = () => {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);
  return null;
};

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <EnquireProvider>
          <BrowserRouter>
            <SmoothScroll />
            <ScrollToTop />
            <div aria-hidden="true" className="grain-overlay pointer-events-none fixed inset-0 z-[45] opacity-[0.07]" />
            <Header />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/biography" element={<Biography />} />
              <Route path="/otto-cilindri-manuale" element={<VJ8C />} />
              <Route path="/bi-venti" element={<BiVenti />} />
            </Routes>
            <Footer />
            <Toaster theme="dark" position="bottom-right" />
          </BrowserRouter>
        </EnquireProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
